const { validateEmail } = require("./regex");

const extractEmailString = (entry) => {
  if (typeof entry === "string") {
    const trimmed = entry.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
  if (entry && typeof entry === "object") {
    if (typeof entry.value === "string") {
      const trimmed = entry.value.trim();
      return trimmed.length > 0 ? trimmed : null;
    }
    if (typeof entry.label === "string") {
      const trimmed = entry.label.trim();
      if (validateEmail(trimmed)) {
        return trimmed;
      }
    }
  }
  return null;
};

const sanitizeCheckoutEmailList = (emails) => {
  const entries = Array.isArray(emails) ? emails : emails != null ? [emails] : [];
  const seen = new Set();
  const result = [];

  for (const entry of entries) {
    const email = extractEmailString(entry);
    if (!email || !validateEmail(email)) {
      continue;
    }
    const key = email.toLowerCase();
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);
    result.push(email);
  }

  return result;
};

const sanitizeCartCheckoutData = (checkoutData) => {
  if (!checkoutData?.communication) {
    return checkoutData;
  }

  const { communication, ...rest } = checkoutData;
  const { pickupContact, ...communicationRest } = communication;

  return {
    ...rest,
    communication: {
      ...communicationRest,
      orderConfirmationEmails: sanitizeCheckoutEmailList(
        communication.orderConfirmationEmails
      ),
      paymentConfirmationEmails: sanitizeCheckoutEmailList(
        communication.paymentConfirmationEmails
      ),
      deliveryTrackingEmails: sanitizeCheckoutEmailList(
        communication.deliveryTrackingEmails
      ),
      pickupContact: pickupContact
        ? {
            ...pickupContact,
            pickupEmails: sanitizeCheckoutEmailList(pickupContact.pickupEmails),
          }
        : pickupContact,
    },
  };
};

const normalizeCheckoutCommunication = (client, existingCommunication = {}) => {
  const defaultEmails = sanitizeCheckoutEmailList(client?.email);
  const resolveList = (list) => {
    const sanitized = sanitizeCheckoutEmailList(list);
    return sanitized.length > 0 ? sanitized : defaultEmails;
  };
  const pickupContact = existingCommunication.pickupContact || {};

  return {
    orderConfirmationEmails: resolveList(
      existingCommunication.orderConfirmationEmails
    ),
    paymentConfirmationEmails: resolveList(
      existingCommunication.paymentConfirmationEmails
    ),
    deliveryTrackingEmails: resolveList(
      existingCommunication.deliveryTrackingEmails
    ),
    pickupContact: {
      ...pickupContact,
      pickupEmails: resolveList(pickupContact.pickupEmails),
      pickupName: pickupContact.pickupName || null,
      pickupPhone: pickupContact.pickupPhone || null,
    },
  };
};

const buildCheckoutCommunicationForClient = (client, existingCommunication) => {
  const communication = normalizeCheckoutCommunication(
    client,
    existingCommunication
  );
  return {
    ...communication,
    pickupContact: {
      ...communication.pickupContact,
      pickupName: communication.pickupContact.pickupName || client?.name || null,
      pickupPhone: communication.pickupContact.pickupPhone || client?.phone || null,
    },
  };
};

module.exports = {
  sanitizeCheckoutEmailList,
  sanitizeCartCheckoutData,
  normalizeCheckoutCommunication,
  buildCheckoutCommunicationForClient,
};
